import _ from 'lodash'
import BaseChartModule from '../BaseChartModule'

class ComposeChart extends BaseChartModule {
  constructor (props) {
    super(props)
    this.state = {
      tooltipCursorWidth: null,
      barSize: null
    }
    this.baseBarWidthPercent = 0.5
    this.baseBarAmount = 20
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      this.updateBarAndCursorWidth()
    }
  }

  initChart = ref => {
    this.chart = ref
    this.updateBarAndCursorWidth()
  }

  updateBarAndCursorWidth = () => {
    const dataSize = _.size(this.props.data)
    const {
      tooltipAxisBandSize: originTooltipAxisBandSize = 0,
      tooltipTicks = []
    } = _.get(this.chart, 'state', {})
    // tooltip 柱狀圖背景寬度
    let tooltipCursorWidth = originTooltipAxisBandSize
    if (tooltipCursorWidth === 0) {
      // 純折線圖算出來 tooltipAxisBandSize 是 0 會造成寬度為 0 無法顯示 cursor
      // 手動計算折線圖兩點間的距離就是 tooltip cursor 的寬度
      const manualCalcCursorWidth = Math.abs(
        _.get(tooltipTicks, '[1].coordinate') - _.get(tooltipTicks, '[0].coordinate')
      )
      if (!_.isNaN(manualCalcCursorWidth)) {
        tooltipCursorWidth = manualCalcCursorWidth
      }
    }
    // 柱狀圖寬度計算(大約)
    const percent = (
      this.baseBarWidthPercent +
      (_.round((dataSize / this.baseBarAmount)) * 0.1)
    )
    const barSize = tooltipCursorWidth * (percent >= 0.9 ? undefined : percent)
    this.setState({
      tooltipCursorWidth,
      barSize
    })
  }

  render () {
    return this.render()
  }
}

export default ComposeChart
